import AbstractModule from './AbstractModule';
import {$document, $body} from '../utils/environment';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.init();



    }

    /**
     * Initialiation.
     *
     * @return {void}
     */
    init() {

        $('.js-toggle-article-navigation').on('click.ArticleNavigation',((event)=>this.toggle(event)));
        $document.on('close.ArticleNavigation',(event)=>this.close(event));

    }


    toggle(e){
        $body.toggleClass('article-navigation-is-open');
    }

    close(e){
        $body.removeClass('article-navigation-is-open');
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.ArticleNavigation');
        $('.js-toggle-article-navigation').off('.ArticleNavigation');
    }
}
